import { ReactNode } from 'react'
import { Box } from '@mui/material'
import { FilterListOff, TableRowsOutlined } from '@mui/icons-material'

const Overlay = ({
  icon,
  title,
  text,
}: {
  icon: ReactNode
  title: string
  text: string
}) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      p: '24px',
      textAlign: 'center',
      '& svg': { fontSize: 28, color: 'var(--ink-300)' },
    }}
  >
    {icon}
    <Box sx={{ fontSize: 14, fontWeight: 700, color: 'var(--ink-700)' }}>
      {title}
    </Box>
    <Box sx={{ fontSize: 12, color: 'var(--ink-500)', maxWidth: 320 }}>
      {text}
    </Box>
  </Box>
)

/**
 * The grid's two empty states (design system: DataGrid, EmptyState). They are
 * different on purpose: an empty table and a table filtered to nothing need
 * different next steps, and MUI's stock "No rows" says the same for both.
 */
export const NoRowsOverlay = () => (
  <Overlay
    icon={<TableRowsOutlined />}
    title="No rows"
    text="There is nothing in this table yet."
  />
)

export const NoResultsOverlay = () => (
  <Overlay
    icon={<FilterListOff />}
    title="No rows match"
    text="Clear the search or the filters to see every row."
  />
)
